import React from 'react';
import { 
  Award, 
  Calendar, 
  CheckCircle, 
  Clock, 
  FileText, 
  GraduationCap,
  UserCheck 
} from 'lucide-react';

const ProcesVerbalStatsCards = ({ procesVerbal }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'Non définie';
    return new Date(dateString).toLocaleDateString('fr-FR');
  };

  const formatTime = (timeString) => {
    if (!timeString) return 'Non définie';
    return timeString.slice(0, 5);
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'validé':
      case 'valide':
        return 'text-green-600 bg-green-50';
      case 'en_attente':
      case 'en attente':
        return 'text-yellow-600 bg-yellow-50';
      case 'brouillon':
        return 'text-gray-600 bg-gray-50';
      default:
        return 'text-blue-600 bg-blue-50';
    }
  };

  const getMentionLabel = (mention) => {
    const mentionLabels = {
      'AJOURNE': 'Ajourné',
      'PASSABLE': 'Passable',
      'ASSEZ_BIEN': 'Assez bien',
      'BIEN': 'Bien',
      'TRES_BIEN': 'Très bien',
      'EXCELLENT': 'Excellent'
    };
    return mentionLabels[mention] || mention || 'Non attribuée';
  };

  const getDecisionLabel = (decision) => {
    const decisionLabels = {
      'ADMIS': 'Admis',
      'ADMIS_RESERVE': 'Admis avec réserve',
      'AJOURNE': 'Ajourné',
      'REPORTE': 'Reporté'
    };
    return decisionLabels[decision] || decision || 'En attente';
  };

  const getMentionColor = (mention) => {
    switch (mention) {
      case 'EXCELLENT':
        return 'text-purple-600 bg-purple-50';
      case 'TRES_BIEN':
        return 'text-green-600 bg-green-50';
      case 'BIEN':
        return 'text-blue-600 bg-blue-50';
      case 'ASSEZ_BIEN':
        return 'text-yellow-600 bg-yellow-50';
      case 'PASSABLE':
        return 'text-orange-600 bg-orange-50';
      case 'AJOURNE':
        return 'text-red-600 bg-red-50';
      default:
        return 'text-gray-600 bg-gray-50';
    }
  };

  const getDecisionColor = (decision) => {
    switch (decision) {
      case 'ADMIS':
        return 'text-green-600 bg-green-50';
      case 'ADMIS_RESERVE':
        return 'text-yellow-600 bg-yellow-50';
      case 'AJOURNE':
        return 'text-red-600 bg-red-50';
      case 'REPORTE':
        return 'text-orange-600 bg-orange-50';
      default:
        return 'text-gray-600 bg-gray-50';
    }
  };

  const soutenance = procesVerbal?.soutenance;

  const cards = [
    {
      title: 'Date de soutenance',
      value: formatDate(soutenance?.date_soutenance),
      icon: Calendar,
      color: 'text-blue-600 bg-blue-50'
    },
    {
      title: 'Heure',
      value: `${formatTime(procesVerbal?.heure_debut)} - ${formatTime(procesVerbal?.heure_fin)}`,
      icon: Clock,
      color: 'text-indigo-600 bg-indigo-50'
    },
    {
      title: 'Note finale',
      value: procesVerbal?.note_finale ? `${procesVerbal.note_finale}/20` : 'Non attribuée',
      icon: Award,
      color: 'text-purple-600 bg-purple-50'
    },
    {
      title: 'Mention',
      value: getMentionLabel(procesVerbal?.mention),
      icon: GraduationCap,
      color: getMentionColor(procesVerbal?.mention)
    },
    {
      title: 'Décision',
      value: getDecisionLabel(procesVerbal?.decision),
      icon: CheckCircle,
      color: getDecisionColor(procesVerbal?.decision)
    },
    {
      title: 'Statut',
      value: procesVerbal?.valide ? 'Validé' : 'Brouillon',
      icon: FileText,
      color: getStatusColor(procesVerbal?.valide ? 'validé' : 'brouillon')
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8 print:hidden">
      {cards.map((card, index) => (
        <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="flex items-center">
            <div className={`p-3 rounded-lg ${card.color}`}>
              <card.icon className="h-6 w-6" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">{card.title}</p>
              <p className="text-lg font-semibold text-gray-900">{card.value}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProcesVerbalStatsCards; 